module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ts-dialog', {
    attrs: {
      "close-on-press-escape": false,
      "width": "70%",
      "title": "请框选图中要识别的区域"
    },
    on: {
      "close": _vm.handleClose
    },
    model: {
      value: (_vm.dialog.show),
      callback: function($$v) {
        _vm.dialog.show = $$v
      },
      expression: "dialog.show"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('vueCropper', {
    ref: "cropper",
    attrs: {
      "img": _vm.Pic.url,
      "outputSize": _vm.example2.size,
      "outputType": _vm.example2.outputType,
      "info": _vm.example2.info,
      "canScale": _vm.example2.canScale,
      "autoCrop": _vm.example2.autoCrop,
      "autoCropWidth": _vm.example2.width,
      "autoCropHeight": _vm.example2.height
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-editPic--menu"
  }, _vm._l((_vm.DICT.productType), function(item) {
    return _c('ts-button', {
      key: item.dicValue,
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.handleLookProduct(item.dicValue)
        }
      }
    }, [_vm._v("搜" + _vm._s(item.label))])
  })), _vm._v(" "), _c('div', {
    slot: "footer"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-41abb1a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/searchImgDialog.vue
// module id = 825
// module chunks = 39